import React, { Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Nav from './components/Nav';
import Hero from './components/sections/Hero';
import Ticker from './components/sections/Ticker';
import WhatsAppFloat from './components/WhatsAppFloat';

const About = React.lazy(() => import('./components/sections/About'));
const Services = React.lazy(() => import('./components/sections/Services'));
const CTA = React.lazy(() => import('./components/sections/CTA'));
const Features = React.lazy(() => import('./components/sections/Features'));
const Products = React.lazy(() => import('./components/sections/Products'));
const Team = React.lazy(() => import('./components/sections/Team'));
const Footer = React.lazy(() => import('./components/Footer'));

function Home() {
  return (
    <>
      <Nav />
      <Hero />
      <Ticker />
      <Suspense fallback={null}>
        <About />
        <Services />
        <CTA />
        <Features />
        <Products />
        <Team />
        <Footer />
      </Suspense>
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;